import { useState } from "react"
import "../../listSelect.css"
import { buildings } from "../../../../data/selectOptions"
import { buildingsAll } from "../../../../data/Kilroid/buildings"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const BuildingSelect =(props) => {
    
    const selectList = buildings //tabulka s udajmi o budovach

    const selectListRes = buildingsAll.filter(building => building.type === 1) // filter resources
    const selectListMil = buildingsAll.filter(building => building.type === 2) // filter military
    const selectListInf = buildingsAll.filter(building => building.type === 3) // filter infra

    const [selectValue, setSelectValue] = useState("")  // hodnota prveho vyberu typu budovy
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
        
     }
     const [selectValueLvl,setSelectValueLvl] = useState("") // hodnota lvl jednotlivej budovy
     const handleSelectValueLvl = event => {
        setSelectValueLvl(event.target.value)
     }

// usestaty pre jednotlive typy budov 
// vycitavanie max levelu stavby a vytvorenie zoynamu tych levelov
    const [BuildingRes, setBuildingRes] = useState({name:"",selected:[], lvlArray:[]})  
    const handleBuildingRes = event =>{
        setBuildingRes({name:(event.target.value),
               selected:(selectListRes.find(building => building.name === event.target.value)),
               lvlArray:(Array.from({ length: ( selectListRes.find(building => building.name === event.target.value)).maxLvl }, (_, i) => ({ id: i, name: i + 1 })))})
    }
    const [BuildingInf, setBuildingInf] = useState({name:"",selected:[], lvlArray:[]})
    const handleBuildingInf = event =>{
        setBuildingInf({name:(event.target.value),
               selected:(selectListInf.find(building => building.name === event.target.value)),
               lvlArray:(Array.from({ length: ( selectListInf.find(building => building.name === event.target.value)).maxLvl }, (_, i) => ({ id: i, name: i + 1 })))})
    }
    const [BuildingMil, setBuildingMil] = useState({name:"",selected:[], lvlArray:[]})
    const handleBuildingMil = event =>{
        setBuildingMil({name:(event.target.value),
               selected:(selectListMil.find(building => building.name === event.target.value)),
               lvlArray:(Array.from({ length: ( selectListMil.find(building => building.name === event.target.value)).maxLvl }, (_, i) => ({ id: i, name: i + 1 })))})
    }
    
// zaokruhlenie na 5
    const rounded5 = (num) => {
        return Math.round(num / 5) * 5;
      };

   
// posielanie selectu do vypisu
        function vypis(building,lvl) {
            const currentValue = [building.selected.cost[0],building.selected.cost[1],building.selected.cost[2],building.selected.cost[3]]
            const constantMultiplier = building.selected.k
            const targetLevel = lvl
            let wood = currentValue[0]
            let clay = currentValue[1]
            let iron = currentValue[2]
            let crop = currentValue[3]
            let all 
            for (let i = 1; i <= targetLevel; i++) {
            wood *= constantMultiplier
            clay *= constantMultiplier
            iron *= constantMultiplier
            crop *= constantMultiplier
            }
            all = rounded5(wood) + rounded5(clay) +rounded5(iron) + rounded5(crop)
            const item = [{id:1, name: building.name + " " + (parseInt(lvl, 10) + 1)
            , wood:rounded5(wood), clay:rounded5(clay), iron:rounded5(iron), crop:rounded5(crop), all:all}]
            props.addItem(item[0])
        }
        
    
return (
    <div>
        <ListSelect label="...choose type..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ==="1" ? (
            <>
                <ListSelect label="...choose building" selectList={selectListRes} handleSelectValue={handleBuildingRes}/>
                {BuildingRes.name !== "" ? (
                    <div>
                        <ListSelect label="...choose level" selectList={BuildingRes.lvlArray} handleSelectValue={handleSelectValueLvl}/>
                        <Btn className="btn" type="submit" text="Add to result" onClick={() =>vypis(BuildingRes, selectValueLvl)} />
                    </div>
                ) : null}
            </>
    ) :
        selectValue ==="2" ? (
            <>
                <ListSelect label="...choose building" selectList={selectListMil} handleSelectValue={handleBuildingMil}/>
                {BuildingMil.name !== "" ? (
                    <div>
                        <ListSelect label="...choose level" selectList={BuildingMil.lvlArray} handleSelectValue={handleSelectValueLvl}/>
                        <Btn className="btn" type="submit" text="Add to result" onClick={() =>vypis(BuildingMil, selectValueLvl)} />
                    </div>
                ) : null}
            </>
        ) :
        selectValue ==="3" ? (
            <>
                <ListSelect label="...choose building" selectList={selectListInf} handleSelectValue={handleBuildingInf}/>
                {BuildingInf.name !== "" ? (
                    <div>
                        <ListSelect label="...choose level" selectList={BuildingInf.lvlArray} handleSelectValue={handleSelectValueLvl}/>
                        <Btn className="btn" type="submit" text="Add to result" onClick={() =>vypis(BuildingInf, selectValueLvl)} />
                    </div>
                ) : null}
            </>
        ) : null
        }
    </div>
)
}
export default BuildingSelect